var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_572_4849",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_572_4849)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.84964 16.825L11.9996 14.925L15.1496 16.85L14.3246 13.25L17.0996 10.85L13.4496 10.525L11.9996 7.12499L10.5496 10.5L6.89964 10.825L9.67464 13.25L8.84964 16.825ZM11.9996 16.6885L8.10939 19.0345C7.96439 19.1192 7.81914 19.1547 7.67364 19.1412C7.52814 19.1277 7.39648 19.0787 7.27864 18.9942C7.16064 18.9096 7.06956 18.799 7.00539 18.6625C6.94139 18.526 6.93114 18.375 6.97464 18.2095L8.00739 13.7922L4.57289 10.8192C4.44456 10.7077 4.36281 10.5786 4.32764 10.4317C4.29231 10.2849 4.30156 10.1422 4.35539 10.0037C4.40923 9.86541 4.48681 9.75232 4.58814 9.66449C4.68948 9.57665 4.82798 9.51924 5.00364 9.49224L9.53614 9.09624L11.2959 4.92499C11.3599 4.76982 11.457 4.65507 11.5871 4.58074C11.7173 4.5064 11.8548 4.46924 11.9996 4.46924C12.1445 4.46924 12.282 4.5064 12.4121 4.58074C12.5423 4.65507 12.6394 4.76982 12.7034 4.92499L14.4631 9.09624L18.9956 9.49224C19.1713 9.51924 19.3098 9.57665 19.4111 9.66449C19.5125 9.75232 19.5901 9.86541 19.6439 10.0037C19.6977 10.1422 19.707 10.2849 19.6716 10.4317C19.6365 10.5786 19.5547 10.7077 19.4264 10.8192L15.9919 13.7922L17.0246 18.2095C17.0681 18.375 17.0579 18.526 16.9939 18.6625C16.9297 18.799 16.8386 18.9096 16.7206 18.9942C16.6028 19.0787 16.4711 19.1277 16.3256 19.1412C16.1801 19.1547 16.0349 19.1192 15.8899 19.0345L11.9996 16.6885Z",
    fill: "#FAFAFA"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStar);
export default __webpack_public_path__ + "static/media/iconStar.b3887ccc9e2e9eada7d6bd7cc0ba96bd.svg";
export { ForwardRef as ReactComponent };